import {
  ZDrawTypeFullResult,
  ZEntryLine,
} from '@daymade/common-lib/dbJsonModels';
import { ensureSubsetOfKeys } from '@daymade/common-lib/types';
import { z } from 'zod';
import {
  zodInsertPrizeOrder,
  zodInsertPrizeOrderProduct,
  zodInsertPrizeWin,
  zodSelectDraw,
  zodSelectDrawType,
  zodSelectPlayer,
  zodSelectPrizeOrder,
  zodSelectPrizeOrderProduct,
  zodSelectPrizeWin,
  zodSelectTicketEntry,
} from '../generated/zodSchemas.generated';

export const ZAdditionalInfo = z.record(z.string(), z.string());

export const ZPrizeWinSelect = zodSelectPrizeWin.extend(
  ensureSubsetOfKeys(zodSelectPrizeWin.shape, {
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    expiresAt: z.coerce.date().nullable(),
    chosenAt: z.coerce.date().nullable(),
  }),
);
export const ZPrizeWinInsert = zodInsertPrizeWin;

export const ZPrizeOrderSelect = zodSelectPrizeOrder.extend(
  ensureSubsetOfKeys(zodSelectPrizeOrder.shape, {
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    confirmedAt: z.coerce.date().nullable(),
    additionalInfoFromPlayer: ZAdditionalInfo,
  }),
);
export const ZPrizeOrderInsert = zodInsertPrizeOrder.extend(
  ensureSubsetOfKeys(zodInsertPrizeOrder.shape, {
    // WORKAROUND: drizzle-zod not inferring json field's type
    additionalInfoFromPlayer: ZAdditionalInfo,
  }),
);

export const ZPrizeOrderProductSelect = zodSelectPrizeOrderProduct.extend(
  ensureSubsetOfKeys(zodSelectPrizeOrderProduct.shape, {
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    awardedAt: z.coerce.date().nullable(),
  }),
);

export const ZPrizeOrderProductInsert = zodInsertPrizeOrderProduct;

export const ZTicketEntrySelect = zodSelectTicketEntry.extend(
  ensureSubsetOfKeys(zodSelectTicketEntry.shape, {
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    entry: ZEntryLine,
  }),
);

export const ZDrawSelect = zodSelectDraw.extend(
  ensureSubsetOfKeys(zodSelectDraw.shape, {
    drawDate: z.coerce.date(),
    result: ZDrawTypeFullResult,
  }),
);

export const ZDrawTypeSelect = zodSelectDrawType.extend(
  ensureSubsetOfKeys(zodSelectDrawType.shape, {
    numberSetup: ZEntryLine,
  }),
);

export const ZPlayerSelect = zodSelectPlayer;

export const ZSubmitPrizeChoiceRequest = z
  .object({
    prizeWinId: z.string(),
    prizeId: z.coerce.number(),
    productId: z.coerce.number().optional(),
  })
  .merge(
    ZPrizeOrderInsert.pick({
      deliveryStreet: true,
      deliveryCity: true,
      deliveryPostcode: true,
      emailAddress: true,
      phoneNumber: true,
      additionalInfoFromPlayer: true,
    }),
  );
export type TSubmitPrizeChoiceRequest = z.infer<
  typeof ZSubmitPrizeChoiceRequest
>;
